import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import { breakpoints, colors, radius, spacing } from '@/styles/designTokens'

/**
 * Drag pill shown at the top of every mobile bottom-sheet drawer.
 * Hidden at desktopSm (720px+) via display:none — always render with aria-hidden="true".
 */
export const DrawerPuller = styled(Box)({
	width: 80,
	height: 8,
	borderRadius: radius.dragPill,
	backgroundColor: colors.overlaySubtle,
	margin: `${spacing.sm}px auto`,
	flexShrink: 0,
	[`@media (min-width: ${breakpoints.desktopSm}px)`]: {
		display: 'none',
	},
})
